import * as React from 'react';
export const IcAlignmentHorizontal = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.71 11.29l-3-3a.988.988 0 00-1.09-.22c-.37.15-.62.52-.62.92v2H7v-2c0-.4-.24-.77-.62-.92a.984.984 0 00-1.09.22l-3 3a.996.996 0 000 1.41l3 3c.19.19.45.29.71.29.13 0 .26-.02.38-.08.37-.15.62-.52.62-.92v-2h10v2c0 .4.24.77.62.92a.995.995 0 001.09-.21l3-3a.996.996 0 000-1.41z'
      fill='currentColor'
    />
  </svg>
);
